// base
export interface IPictureBaseModel  {
    Id?: Number
    ItemState?: Number
    PropertyId?: Number
    PictureNumber?: Number
    OriginalUrl?: string

    // custom
    IsMissingOnCloud?: boolean;
    OriginalPublishUrl?:string
} 

export class PictureBaseModel implements IPictureBaseModel {
    Id?: Number
    ItemState?: Number
    PropertyId?: Number
    PictureNumber?: Number
    OriginalUrl?: string

    // custom
    IsMissingOnCloud?: boolean;
    OriginalPublishUrl?:string

    constructor(option?: IPictureBaseModel) {
        if (option) {
            this.Id = option.Id || 0;
            this.ItemState = option.ItemState || 0;
            this.PropertyId = option.PropertyId
            this.PictureNumber = option.PictureNumber || 0;
            this.OriginalUrl = option.OriginalUrl || null;
            this.OriginalPublishUrl = option.OriginalPublishUrl || null;
        }
    }
}

// main
export interface IPictureModel extends IPictureBaseModel {
    DescriptionOfNL?: string;
    DescriptionOfSP?: string;
    DescriptionOfCA?: string;
    DescriptionOfEN?: string;
    DescriptionOfDE?: string;
    DescriptionOfFR?: string;
    SmallUrl?: string;
    MediumUrl?: string;
    LargeUrl?: string;
    XLargeUrl?: string;
    WidthOfImage?: number;
    HeightOfImage?: number;
    PublishOnInternet?: boolean;
    PictureTypeIds?: PictureTypeItemModel[];
    PictureRoomIds?: PictureRoomItemModel[];
    
    // custom
    SmallPublishUrl?: string;
} 

export class PictureModel extends PictureBaseModel implements IPictureModel {
    DescriptionOfNL?: string;
    DescriptionOfSP?: string;
    DescriptionOfCA?: string;
    DescriptionOfEN?: string;
    DescriptionOfDE?: string;
    DescriptionOfFR?: string;
    SmallUrl?: string;
    MediumUrl?: string;
    LargeUrl?: string;
    XLargeUrl?: string;
    WidthOfImage?: number;
    HeightOfImage?: number;
    PublishOnInternet?: boolean;
    PictureTypeIds?: PictureTypeItemModel[];
    PictureRoomIds?: PictureRoomItemModel[];
    // custom
    SmallPublishUrl?: string;

    constructor(options?: IPictureModel) {
        super(options);
        
        if (options) {
            this.PictureTypeIds = options.PictureTypeIds || [];
            this.PictureRoomIds = options.PictureRoomIds || [];
            this.DescriptionOfNL = options.DescriptionOfNL || null;
            this.DescriptionOfSP = options.DescriptionOfSP || null;
            this.DescriptionOfCA = options.DescriptionOfCA || null;
            this.DescriptionOfEN = options.DescriptionOfEN || null;
            this.DescriptionOfDE = options.DescriptionOfDE || null;
            this.DescriptionOfFR = options.DescriptionOfFR || null;
            this.SmallUrl = options.SmallUrl || null;
            this.MediumUrl = options.MediumUrl || null;
            this.LargeUrl = options.LargeUrl || null;
            this.XLargeUrl = options.XLargeUrl || null;
            this.WidthOfImage = options.WidthOfImage || 0;
            this.HeightOfImage = options.HeightOfImage || 0;
            this.PublishOnInternet = options.PublishOnInternet || false;
    
            // custom
            this.SmallPublishUrl= options.SmallPublishUrl || null;
        }
    }
}

export class PictureTypeItemModel {
    Id: number;
    ItemState?: number;
}

export class PictureRoomItemModel {
    Id: number;
    ItemState?: number;
    OrderNr: number;
}


